var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmptyStateExperiences = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 38,
    viewBox: "0 0 48 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 3H4C3.44772 3 3 3.44772 3 4V28C3 28.5523 3.44772 29 4 29H38C38.5523 29 39 28.5523 39 28V4C39 3.44772 38.5523 3 38 3ZM4 0C1.79086 0 0 1.79086 0 4V28C0 30.2091 1.79086 32 4 32H6V34C6 36.2091 7.79086 38 10 38H44C46.2091 38 48 36.2091 48 34V10C48 7.79086 46.2091 6 44 6H42V4C42 1.79086 40.2091 0 38 0H4ZM9 34V32H38C40.2091 32 42 30.2091 42 28V9H44C44.5523 9 45 9.44771 45 10V34C45 34.5523 44.5523 35 44 35H10C9.44772 35 9 34.5523 9 34ZM13 9C14.1046 9 15 8.10457 15 7C15 5.89543 14.1046 5 13 5C11.8954 5 11 5.89543 11 7C11 8.10457 11.8954 9 13 9ZM9 7C9 8.10457 8.10457 9 7 9C5.89543 9 5 8.10457 5 7C5 5.89543 5.89543 5 7 5C8.10457 5 9 5.89543 9 7ZM19 9C20.1046 9 21 8.10457 21 7C21 5.89543 20.1046 5 19 5C17.8954 5 17 5.89543 17 7C17 8.10457 17.8954 9 19 9Z",
    fill: "#071A24"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyStateExperiences);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/EmptyStateExperiences.0fdc03d08952226f9bf8d56923a9b95a.svg";